import React, { useEffect, useState } from 'react'
import { FiUsers } from 'react-icons/fi';
import { MdInsertEmoticon } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { LoadAllSchool } from '../../actions/Activites/School';
import { LoadAllEmail } from '../../actions/Emails/EmailsAction';
import { LoadAllMember } from '../../actions/Members/MemberAction';
import { LoadAllMessage } from '../../actions/Messages/MessageAction';
import { LoadAllTemoignage } from '../../actions/Temoignages/TemoignageAction';
import { LoadAllUser } from '../../actions/Users/UserAction';
import MemberCompDashBoard from '../../components/admin/dasboard/MemberCompDashBoard';
import UserCompoDashboard from '../../components/admin/dasboard/UserCompoDashboard';
import AllRoutes from '../../nametitle/AllRoutes';
import {GrCirclePlay} from "react-icons/gr";


const DasboardAdmin = () => {
  const  navigate =  useNavigate();
  const bgImg1 = "https://images.pexels.com/photos/5063055/pexels-photo-5063055.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";
  const bgImg2 = "https://images.pexels.com/photos/5063055/pexels-photo-5063055.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";
  const bgImg3 = "https://images.pexels.com/photos/5063055/pexels-photo-5063055.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";
  const bgImg4 = "https://images.pexels.com/photos/5063055/pexels-photo-5063055.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1";


  const [userlist, setuserlist] = useState([]);
  const [memberList, setmemberList] = useState([]);
  const [temoignageList, settemoignageList] = useState([]);
  const [emailList, setemailList] = useState([]);
  const [messageList, setmessageList] = useState([]);
  const [enseignementList, setenseignementList] = useState([]);
  useEffect(() => {
    LoadAllUser(setuserlist);
    LoadAllMember(setmemberList)
    LoadAllTemoignage(settemoignageList);
    LoadAllMessage(setmessageList);
    LoadAllEmail(setemailList);
    LoadAllSchool(setenseignementList);
  }, [])
  

  
  return (
    <div className="translatable container-fluid w-full p-2">
      <div className="translatable w-full ">
        <h2 className="translatable px-5 py-3 text-2xl bg-gray-400 rounded-lg mb-3">Accueil</h2>
        
        {/*  */}
        <div className="translatable grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-3">
          <div className="translatable bg-lime-600 text-white flex space-x-2 rounded-lg p-2 px-1">
            <div><img src={`${bgImg1}`} className="translatable h-10 w-10" /></div>
            <div>
              <h2 className="translatable text-2xl font-bold flex"><MdInsertEmoticon/>Témoignages</h2>
              <div>
                <label>
                  nombres : <span className="translatable font-bold text-2xl ">{temoignageList.length}</span>
                </label>
              </div>
              <div>
                <button onClick={()=>{navigate(`/${AllRoutes.admin}/${AllRoutes.temoins}`)}} className="translatable hover:underline bg-light py-1 px-2 rounded-lg text-lime-700 ">
                  voire
                </button>
              </div>
            </div>
          </div>
          <div className="translatable bg-lime-600 text-white flex space-x-2 rounded-lg p-2 px-1">
            <div><img src={`${bgImg1}`} className="translatable h-10 w-10" /></div>
            <div>
              <h2 className="translatable text-2xl font-bold flex"><GrCirclePlay/>enseignements</h2>
              <div>
                <label>
                  nombres : <span className="translatable font-bold text-2xl ">{enseignementList.length}</span>
                </label>
              </div>
              <div>
                <button onClick={()=>{navigate(`/${AllRoutes.admin}/${AllRoutes.activity}`)}} className="translatable hover:underline bg-light py-1 px-2 rounded-lg text-lime-700 ">
                  voire
                </button>
              </div>
            </div>
          </div>
          <div className="translatable bg-lime-600 text-white flex space-x-2 rounded-lg p-2 px-1">
            <div><img src={`${bgImg1}`} className="translatable h-10 w-10" /></div>
            <div>
              <h2 className="translatable text-2xl font-bold flex"><FiUsers/> Membres</h2>
              <div>
                <label>
                  nombres : <span className="translatable font-bold text-2xl ">{memberList.length}</span>
                </label>
              </div>
              <div>
                <button onClick={()=>{navigate(`/${AllRoutes.admin}/${AllRoutes.memberlist}`)}} className="translatable hover:underline bg-light py-1 px-2 rounded-lg text-lime-700 ">
                  voire
                </button>
              </div>
            </div>
          </div>
          <div className="translatable bg-lime-600 text-white flex space-x-2 rounded-lg p-2 px-1">
            <div><img src={`${bgImg1}`} className="translatable h-10 w-10" /></div>
            <div>
              <h2 className="translatable text-2xl font-bold flex"><FiUsers/>Messages</h2>
              <div>
                <label>
                  nombres : <span className="translatable font-bold text-2xl ">{messageList.length}</span>
                </label>
              </div>
              <div>
                <button onClick={()=>{navigate(`/${AllRoutes.admin}/${AllRoutes.message}`)}} className="translatable hover:underline bg-light py-1 px-2 rounded-lg text-lime-700 ">
                  voire
                </button>
              </div>
            </div>
          </div>

          <div className="translatable bg-lime-600 text-white flex space-x-2 rounded-lg p-2 px-1">
            <div><img src={`${bgImg1}`} className="translatable h-10 w-10" /></div>
            <div>
              <h2 className="translatable text-2xl font-bold flex"><FiUsers/>Email reçus</h2>
              <div>
                <label>
                  nombres : <span className="translatable font-bold text-2xl ">{emailList.length}</span>
                </label>
              </div>
              <div>
                <button onClick={()=>{navigate(`/${AllRoutes.admin}/${AllRoutes.emaillist}`)}} className="translatable hover:underline bg-light py-1 px-2 rounded-lg text-lime-700 ">
                  voire
                </button>
              </div>
            </div>
          </div>
          <div className="translatable bg-lime-600 text-white flex space-x-2 rounded-lg p-2 px-1">
            <div><img src={`${bgImg1}`} className="translatable h-10 w-10" /></div>
            <div>
              <h2 className="translatable text-2xl font-bold flex"><FiUsers/> utilisateur</h2>
              <div>
                <label>
                  nombres : <span className="translatable font-bold text-2xl ">{userlist.length}</span>
                </label>
              </div>
              <div>
                <button onClick={()=>{navigate(`/${AllRoutes.admin}/${AllRoutes.userlist}`)}} className="translatable hover:underline bg-light py-1 px-2 rounded-lg text-lime-700 ">
                  voire
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="translatable grid grid-cols-2 gap-3 mt-5">
         {
          /*
           <UserCompoDashboard/>
          <MemberCompDashBoard/>
          */
         }
        </div>

      </div>
    </div>
  )
}

export default DasboardAdmin;